module.exports = __webpack_public_path__ + "static/img/manual-48.9708dfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-48.png
// module id = H/hQ
// module chunks = 4